import { Share } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { FormattedMessage } from '../FormattedMessage';
import { Root } from './styles';
import type { ShareButtonProps } from './types';

export const ShareButton: FC<ShareButtonProps> = ({ isSharingButtonActive, onClick }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      data-testid={getTestId('minibag-share-panel-button')}
      color="secondary"
      disabled={!isSharingButtonActive}
      variant="contained"
      onClick={onClick}
    >
      <Share />
      <FormattedMessage id="shareYourBasket" />
    </Root>
  );
};
